import { Backdrop, Modal } from '@mui/material';
import React from 'react';
import './index.scss';

interface PopupProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactElement;
}

const Popup: React.FC<PopupProps> = ({ open, onClose, children }) => {
  // Focus trap and ESC to close
  const modalRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (open && modalRef.current) {
      modalRef.current.focus();
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (open) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);
  return (
  <Modal
      closeAfterTransition
      aria-modal="true"
      open={open}
      role="dialog"
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      slots={{ backdrop: Backdrop }}
      onClose={onClose}
    >
      <div ref={modalRef} className="popup-no-outline" tabIndex={-1}>
        {children}
      </div>
    </Modal>
  );
};

export default Popup;
